import Page from "src/components/Page";
import useLocales from "src/hooks/useLocales";
import RootStyle from "../shared/rootStyle";
import Header from "./components/Header";
import ImageCard from "./components/ImageCard";
import MainSection from "./components/MainSection";

const Login = () => {
  const { translate } = useLocales();
  return (
    <Page title={translate("auth.login.pageTitle")}>
      <RootStyle>
        <Header />
        <ImageCard />
        <MainSection />
      </RootStyle>
    </Page>
  );
};

export default Login;
